/** Agent withdrawal logs page — non-English overrides */
export const panelAgentLogsByLang = {
  es: {
    'agent.logs.emptyTitle': 'No se encontraron retiros',
    'agent.logs.emptyDescAdjust': 'Prueba a ajustar los filtros o el rango de fechas',
    'agent.logs.subtitle': 'Historial completo de todas las solicitudes de retiro',
    'agent.logs.loadingRows': 'Cargando retiros…',
    'agent.logs.col.dateTime': 'Fecha y hora',
    'agent.logs.col.amount': 'Monto',
    'agent.logs.col.wallet': 'Billetera',
    'agent.logs.col.network': 'Red',
    'agent.logs.col.fee': 'Comisión',
    'agent.logs.col.status': 'Estado',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'Procesado en',
    'agent.logs.expanded.txId': 'ID de transacción',
    'agent.logs.expanded.fullWallet': 'Dirección completa de billetera',
    'agent.logs.expanded.network': 'Red',
    'agent.logs.expanded.processingTime': 'Tiempo de procesamiento',
    'agent.logs.awaitingReview': 'En revisión',
    'agent.logs.failedHelp':
      'Este retiro falló. Contacta soporte con TXID {{txid}} para asistencia.',
    'agent.logs.pendingNotice': 'El retiro está en revisión. Tiempo de procesamiento: 24–48 horas.',
    'agent.logs.status.completed': 'Completado',
    'agent.logs.status.pending': 'Pendiente',
    'agent.logs.status.failed': 'Fallido',
    'agent.logs.filter.all': 'Todos',
    'agent.logs.filter.from': 'Desde',
    'agent.logs.filter.to': 'Hasta',
    'agent.logs.filter.searchPlaceholder': 'Buscar por TXID o billetera…',
    'agent.logs.summary.totalWithdrawn': 'Total retirado',
    'agent.logs.summary.lastWithdrawal': 'Último retiro',
    'agent.logs.summary.nextAvailable': 'Próximo disponible',
    'agent.logs.summary.subTotalWithdrawn': 'Retiros exitosos',
    'agent.logs.summary.subNextOpen': 'Puedes solicitar ahora',
    'agent.logs.summary.subNextLocked': 'Completa los requisitos de referidos',
    'agent.logs.summary.open': 'Abierto',
    'agent.logs.summary.locked': 'Bloqueado',
    'agent.logs.summary.loading': 'Cargando…',
  },
  de: {
    'agent.logs.emptyTitle': 'Keine Auszahlungen gefunden',
    'agent.logs.emptyDescAdjust': 'Passen Sie Filter oder Datumsbereich an',
    'agent.logs.subtitle': 'Vollständiger Verlauf aller Auszahlungsanfragen',
    'agent.logs.loadingRows': 'Auszahlungen werden geladen…',
    'agent.logs.col.dateTime': 'Datum & Uhrzeit',
    'agent.logs.col.amount': 'Betrag',
    'agent.logs.col.wallet': 'Wallet',
    'agent.logs.col.network': 'Netzwerk',
    'agent.logs.col.fee': 'Gebühr',
    'agent.logs.col.status': 'Status',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'Bearbeitet in',
    'agent.logs.expanded.txId': 'Transaktions-ID',
    'agent.logs.expanded.fullWallet': 'Vollständige Wallet-Adresse',
    'agent.logs.expanded.network': 'Netzwerk',
    'agent.logs.expanded.processingTime': 'Bearbeitungszeit',
    'agent.logs.awaitingReview': 'Wird geprüft',
    'agent.logs.failedHelp':
      'Diese Auszahlung ist fehlgeschlagen. Kontaktieren Sie den Support mit TXID {{txid}}.',
    'agent.logs.pendingNotice': 'Auszahlung wird geprüft. Bearbeitungszeit: 24–48 Stunden.',
    'agent.logs.status.completed': 'Abgeschlossen',
    'agent.logs.status.pending': 'Ausstehend',
    'agent.logs.status.failed': 'Fehlgeschlagen',
    'agent.logs.filter.all': 'Alle',
    'agent.logs.filter.from': 'Von',
    'agent.logs.filter.to': 'Bis',
    'agent.logs.filter.searchPlaceholder': 'Nach TXID oder Wallet suchen…',
    'agent.logs.summary.totalWithdrawn': 'Gesamt ausgezahlt',
    'agent.logs.summary.lastWithdrawal': 'Letzte Auszahlung',
    'agent.logs.summary.nextAvailable': 'Nächste verfügbar',
    'agent.logs.summary.subTotalWithdrawn': 'Erfolgreiche Auszahlungen',
    'agent.logs.summary.subNextOpen': 'Sie können jetzt anfordern',
    'agent.logs.summary.subNextLocked': 'Empfehlungsanforderungen erfüllen',
    'agent.logs.summary.open': 'Offen',
    'agent.logs.summary.locked': 'Gesperrt',
    'agent.logs.summary.loading': 'Laden…',
  },
  fr: {
    'agent.logs.emptyTitle': 'Aucun retrait trouvé',
    'agent.logs.emptyDescAdjust': 'Essayez d\'ajuster les filtres ou la plage de dates',
    'agent.logs.subtitle': 'Historique complet de toutes les demandes de retrait',
    'agent.logs.loadingRows': 'Chargement des retraits…',
    'agent.logs.col.dateTime': 'Date et heure',
    'agent.logs.col.amount': 'Montant',
    'agent.logs.col.wallet': 'Portefeuille',
    'agent.logs.col.network': 'Réseau',
    'agent.logs.col.fee': 'Frais',
    'agent.logs.col.status': 'Statut',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'Traité en',
    'agent.logs.expanded.txId': 'ID de transaction',
    'agent.logs.expanded.fullWallet': 'Adresse complète du portefeuille',
    'agent.logs.expanded.network': 'Réseau',
    'agent.logs.expanded.processingTime': 'Délai de traitement',
    'agent.logs.awaitingReview': 'En cours d\'examen',
    'agent.logs.failedHelp':
      'Ce retrait a échoué. Contactez le support avec le TXID {{txid}} pour assistance.',
    'agent.logs.pendingNotice': 'Retrait en cours d\'examen. Délai : 24 à 48 heures.',
    'agent.logs.status.completed': 'Terminé',
    'agent.logs.status.pending': 'En attente',
    'agent.logs.status.failed': 'Échoué',
    'agent.logs.filter.all': 'Tous',
    'agent.logs.filter.from': 'Du',
    'agent.logs.filter.to': 'Au',
    'agent.logs.filter.searchPlaceholder': 'Rechercher par TXID ou portefeuille…',
    'agent.logs.summary.totalWithdrawn': 'Total retiré',
    'agent.logs.summary.lastWithdrawal': 'Dernier retrait',
    'agent.logs.summary.nextAvailable': 'Prochain disponible',
    'agent.logs.summary.subTotalWithdrawn': 'Retraits réussis',
    'agent.logs.summary.subNextOpen': 'Vous pouvez demander maintenant',
    'agent.logs.summary.subNextLocked': 'Remplissez les exigences de parrainage',
    'agent.logs.summary.open': 'Ouvert',
    'agent.logs.summary.locked': 'Verrouillé',
    'agent.logs.summary.loading': 'Chargement…',
  },
  ar: {
    'agent.logs.emptyTitle': 'لا توجد سحوبات',
    'agent.logs.emptyDescAdjust': 'جرّب تعديل المرشحات أو نطاق التاريخ',
    'agent.logs.subtitle': 'سجل كامل لجميع طلبات السحب',
    'agent.logs.loadingRows': 'جاري تحميل السحوبات…',
    'agent.logs.col.dateTime': 'التاريخ والوقت',
    'agent.logs.col.amount': 'المبلغ',
    'agent.logs.col.wallet': 'المحفظة',
    'agent.logs.col.network': 'الشبكة',
    'agent.logs.col.fee': 'الرسوم',
    'agent.logs.col.status': 'الحالة',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'معالج خلال',
    'agent.logs.expanded.txId': 'معرّف المعاملة',
    'agent.logs.expanded.fullWallet': 'عنوان المحفظة الكامل',
    'agent.logs.expanded.network': 'الشبكة',
    'agent.logs.expanded.processingTime': 'وقت المعالجة',
    'agent.logs.awaitingReview': 'قيد المراجعة',
    'agent.logs.failedHelp': 'فشل هذا السحب. تواصل مع الدعم برقم TXID {{txid}} للمساعدة.',
    'agent.logs.pendingNotice': 'السحب قيد المراجعة. وقت المعالجة 24–48 ساعة.',
    'agent.logs.status.completed': 'مكتمل',
    'agent.logs.status.pending': 'معلق',
    'agent.logs.status.failed': 'فشل',
    'agent.logs.filter.all': 'الكل',
    'agent.logs.filter.from': 'من',
    'agent.logs.filter.to': 'إلى',
    'agent.logs.filter.searchPlaceholder': 'بحث برقم TXID أو المحفظة…',
    'agent.logs.summary.totalWithdrawn': 'إجمالي المسحوب',
    'agent.logs.summary.lastWithdrawal': 'آخر سحب',
    'agent.logs.summary.nextAvailable': 'التالي المتاح',
    'agent.logs.summary.subTotalWithdrawn': 'سحوبات ناجحة',
    'agent.logs.summary.subNextOpen': 'يمكنك الطلب الآن',
    'agent.logs.summary.subNextLocked': 'أكمل متطلبات الإحالة',
    'agent.logs.summary.open': 'مفتوح',
    'agent.logs.summary.locked': 'مقفل',
    'agent.logs.summary.loading': 'جاري التحميل…',
  },
  ja: {
    'agent.logs.emptyTitle': '出金が見つかりません',
    'agent.logs.emptyDescAdjust': 'フィルターまたは日付範囲を調整してください',
    'agent.logs.subtitle': 'すべての出金リクエストの完全な履歴',
    'agent.logs.loadingRows': '出金を読み込み中…',
    'agent.logs.col.dateTime': '日時',
    'agent.logs.col.amount': '金額',
    'agent.logs.col.wallet': 'ウォレット',
    'agent.logs.col.network': 'ネットワーク',
    'agent.logs.col.fee': '手数料',
    'agent.logs.col.status': 'ステータス',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': '処理時間',
    'agent.logs.expanded.txId': 'トランザクションID',
    'agent.logs.expanded.fullWallet': 'ウォレットアドレス全文',
    'agent.logs.expanded.network': 'ネットワーク',
    'agent.logs.expanded.processingTime': '処理時間',
    'agent.logs.awaitingReview': '審査中',
    'agent.logs.failedHelp': 'この出金は失敗しました。TXID {{txid}} でサポートにお問い合わせください。',
    'agent.logs.pendingNotice': '出金は審査中です。処理時間は24〜48時間です。',
    'agent.logs.status.completed': '完了',
    'agent.logs.status.pending': '保留中',
    'agent.logs.status.failed': '失敗',
    'agent.logs.filter.all': 'すべて',
    'agent.logs.filter.from': '開始',
    'agent.logs.filter.to': '終了',
    'agent.logs.filter.searchPlaceholder': 'TXIDまたはウォレットを検索…',
    'agent.logs.summary.totalWithdrawn': '出金合計',
    'agent.logs.summary.lastWithdrawal': '最後の出金',
    'agent.logs.summary.nextAvailable': '次回可能',
    'agent.logs.summary.subTotalWithdrawn': '成功した出金',
    'agent.logs.summary.subNextOpen': '今すぐ申請できます',
    'agent.logs.summary.subNextLocked': '紹介要件を完了してください',
    'agent.logs.summary.open': '開放',
    'agent.logs.summary.locked': 'ロック',
    'agent.logs.summary.loading': '読み込み中…',
  },
  ko: {
    'agent.logs.emptyTitle': '출금을 찾을 수 없습니다',
    'agent.logs.emptyDescAdjust': '필터 또는 날짜 범위를 조정해 보세요',
    'agent.logs.subtitle': '모든 출금 요청의 전체 내역',
    'agent.logs.loadingRows': '출금 불러오는 중…',
    'agent.logs.col.dateTime': '날짜 및 시간',
    'agent.logs.col.amount': '금액',
    'agent.logs.col.wallet': '지갑',
    'agent.logs.col.network': '네트워크',
    'agent.logs.col.fee': '수수료',
    'agent.logs.col.status': '상태',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': '처리 시간',
    'agent.logs.expanded.txId': '거래 ID',
    'agent.logs.expanded.fullWallet': '전체 지갑 주소',
    'agent.logs.expanded.network': '네트워크',
    'agent.logs.expanded.processingTime': '처리 시간',
    'agent.logs.awaitingReview': '검토 중',
    'agent.logs.failedHelp': '출금이 실패했습니다. TXID {{txid}}로 지원팀에 문의하세요.',
    'agent.logs.pendingNotice': '출금이 검토 중입니다. 처리 시간 24–48시간.',
    'agent.logs.status.completed': '완료',
    'agent.logs.status.pending': '대기 중',
    'agent.logs.status.failed': '실패',
    'agent.logs.filter.all': '전체',
    'agent.logs.filter.from': '시작',
    'agent.logs.filter.to': '종료',
    'agent.logs.filter.searchPlaceholder': 'TXID 또는 지갑 검색…',
    'agent.logs.summary.totalWithdrawn': '총 출금액',
    'agent.logs.summary.lastWithdrawal': '마지막 출금',
    'agent.logs.summary.nextAvailable': '다음 가능',
    'agent.logs.summary.subTotalWithdrawn': '성공한 출금',
    'agent.logs.summary.subNextOpen': '지금 요청할 수 있습니다',
    'agent.logs.summary.subNextLocked': '추천 요건을 완료하세요',
    'agent.logs.summary.open': '열림',
    'agent.logs.summary.locked': '잠김',
    'agent.logs.summary.loading': '불러오는 중…',
  },
  'zh-CN': {
    'agent.logs.emptyTitle': '未找到提现',
    'agent.logs.emptyDescAdjust': '请尝试调整筛选条件或日期范围',
    'agent.logs.subtitle': '所有提现申请的完整记录',
    'agent.logs.loadingRows': '正在加载提现…',
    'agent.logs.col.dateTime': '日期和时间',
    'agent.logs.col.amount': '金额',
    'agent.logs.col.wallet': '钱包',
    'agent.logs.col.network': '网络',
    'agent.logs.col.fee': '手续费',
    'agent.logs.col.status': '状态',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': '处理用时',
    'agent.logs.expanded.txId': '交易 ID',
    'agent.logs.expanded.fullWallet': '完整钱包地址',
    'agent.logs.expanded.network': '网络',
    'agent.logs.expanded.processingTime': '处理时间',
    'agent.logs.awaitingReview': '审核中',
    'agent.logs.failedHelp': '此次提现失败。请使用 TXID {{txid}} 联系客服。',
    'agent.logs.pendingNotice': '提现审核中。处理时间 24–48 小时。',
    'agent.logs.status.completed': '已完成',
    'agent.logs.status.pending': '待处理',
    'agent.logs.status.failed': '失败',
    'agent.logs.filter.all': '全部',
    'agent.logs.filter.from': '从',
    'agent.logs.filter.to': '至',
    'agent.logs.filter.searchPlaceholder': '搜索 TXID 或钱包…',
    'agent.logs.summary.totalWithdrawn': '已提现总额',
    'agent.logs.summary.lastWithdrawal': '上次提现',
    'agent.logs.summary.nextAvailable': '下次可用',
    'agent.logs.summary.subTotalWithdrawn': '成功提现',
    'agent.logs.summary.subNextOpen': '您现在可以提交申请',
    'agent.logs.summary.subNextLocked': '完成推荐要求',
    'agent.logs.summary.open': '开放',
    'agent.logs.summary.locked': '锁定',
    'agent.logs.summary.loading': '加载中…',
  },
  pt: {
    'agent.logs.emptyTitle': 'Nenhum saque encontrado',
    'agent.logs.emptyDescAdjust': 'Tente ajustar os filtros ou o intervalo de datas',
    'agent.logs.subtitle': 'Histórico completo de todos os pedidos de saque',
    'agent.logs.loadingRows': 'Carregando saques…',
    'agent.logs.col.dateTime': 'Data e hora',
    'agent.logs.col.amount': 'Valor',
    'agent.logs.col.wallet': 'Carteira',
    'agent.logs.col.network': 'Rede',
    'agent.logs.col.fee': 'Taxa',
    'agent.logs.col.status': 'Status',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'Processado em',
    'agent.logs.expanded.txId': 'ID da transação',
    'agent.logs.expanded.fullWallet': 'Endereço completo da carteira',
    'agent.logs.expanded.network': 'Rede',
    'agent.logs.expanded.processingTime': 'Tempo de processamento',
    'agent.logs.awaitingReview': 'Em análise',
    'agent.logs.failedHelp': 'Este saque falhou. Contate o suporte com TXID {{txid}}.',
    'agent.logs.pendingNotice': 'Saque em análise. Tempo de processamento: 24–48 horas.',
    'agent.logs.status.completed': 'Concluído',
    'agent.logs.status.pending': 'Pendente',
    'agent.logs.status.failed': 'Falhou',
    'agent.logs.filter.all': 'Todos',
    'agent.logs.filter.from': 'De',
    'agent.logs.filter.to': 'Até',
    'agent.logs.filter.searchPlaceholder': 'Pesquisar por TXID ou carteira…',
    'agent.logs.summary.totalWithdrawn': 'Total sacado',
    'agent.logs.summary.lastWithdrawal': 'Último saque',
    'agent.logs.summary.nextAvailable': 'Próximo disponível',
    'agent.logs.summary.subTotalWithdrawn': 'Saques bem-sucedidos',
    'agent.logs.summary.subNextOpen': 'Você pode solicitar agora',
    'agent.logs.summary.subNextLocked': 'Complete os requisitos de indicação',
    'agent.logs.summary.open': 'Aberto',
    'agent.logs.summary.locked': 'Bloqueado',
    'agent.logs.summary.loading': 'Carregando…',
  },
  it: {
    'agent.logs.emptyTitle': 'Nessun prelievo trovato',
    'agent.logs.emptyDescAdjust': 'Prova a modificare filtri o intervallo date',
    'agent.logs.subtitle': 'Cronologia completa di tutte le richieste di prelievo',
    'agent.logs.loadingRows': 'Caricamento prelievi…',
    'agent.logs.col.dateTime': 'Data e ora',
    'agent.logs.col.amount': 'Importo',
    'agent.logs.col.wallet': 'Wallet',
    'agent.logs.col.network': 'Rete',
    'agent.logs.col.fee': 'Commissione',
    'agent.logs.col.status': 'Stato',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'Elaborato in',
    'agent.logs.expanded.txId': 'ID transazione',
    'agent.logs.expanded.fullWallet': 'Indirizzo wallet completo',
    'agent.logs.expanded.network': 'Rete',
    'agent.logs.expanded.processingTime': 'Tempo di elaborazione',
    'agent.logs.awaitingReview': 'In revisione',
    'agent.logs.failedHelp': 'Questo prelievo è fallito. Contatta il supporto con TXID {{txid}}.',
    'agent.logs.pendingNotice': 'Prelievo in revisione. Tempo: 24–48 ore.',
    'agent.logs.status.completed': 'Completato',
    'agent.logs.status.pending': 'In attesa',
    'agent.logs.status.failed': 'Non riuscito',
    'agent.logs.filter.all': 'Tutti',
    'agent.logs.filter.from': 'Da',
    'agent.logs.filter.to': 'A',
    'agent.logs.filter.searchPlaceholder': 'Cerca per TXID o wallet…',
    'agent.logs.summary.totalWithdrawn': 'Totale prelevato',
    'agent.logs.summary.lastWithdrawal': 'Ultimo prelievo',
    'agent.logs.summary.nextAvailable': 'Prossimo disponibile',
    'agent.logs.summary.subTotalWithdrawn': 'Prelievi riusciti',
    'agent.logs.summary.subNextOpen': 'Puoi richiedere ora',
    'agent.logs.summary.subNextLocked': 'Completa i requisiti referral',
    'agent.logs.summary.open': 'Aperto',
    'agent.logs.summary.locked': 'Bloccato',
    'agent.logs.summary.loading': 'Caricamento…',
  },
  ru: {
    'agent.logs.emptyTitle': 'Выводы не найдены',
    'agent.logs.emptyDescAdjust': 'Попробуйте изменить фильтры или диапазон дат',
    'agent.logs.subtitle': 'Полная история всех заявок на вывод',
    'agent.logs.loadingRows': 'Загрузка выводов…',
    'agent.logs.col.dateTime': 'Дата и время',
    'agent.logs.col.amount': 'Сумма',
    'agent.logs.col.wallet': 'Кошелёк',
    'agent.logs.col.network': 'Сеть',
    'agent.logs.col.fee': 'Комиссия',
    'agent.logs.col.status': 'Статус',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'Обработано за',
    'agent.logs.expanded.txId': 'ID транзакции',
    'agent.logs.expanded.fullWallet': 'Полный адрес кошелька',
    'agent.logs.expanded.network': 'Сеть',
    'agent.logs.expanded.processingTime': 'Время обработки',
    'agent.logs.awaitingReview': 'На проверке',
    'agent.logs.failedHelp': 'Вывод не выполнен. Свяжитесь с поддержкой, указав TXID {{txid}}.',
    'agent.logs.pendingNotice': 'Вывод на проверке. Срок обработки 24–48 часов.',
    'agent.logs.status.completed': 'Завершено',
    'agent.logs.status.pending': 'В ожидании',
    'agent.logs.status.failed': 'Ошибка',
    'agent.logs.filter.all': 'Все',
    'agent.logs.filter.from': 'С',
    'agent.logs.filter.to': 'По',
    'agent.logs.filter.searchPlaceholder': 'Поиск по TXID или кошельку…',
    'agent.logs.summary.totalWithdrawn': 'Всего выведено',
    'agent.logs.summary.lastWithdrawal': 'Последний вывод',
    'agent.logs.summary.nextAvailable': 'Следующий доступен',
    'agent.logs.summary.subTotalWithdrawn': 'Успешные выводы',
    'agent.logs.summary.subNextOpen': 'Можно подать заявку сейчас',
    'agent.logs.summary.subNextLocked': 'Выполните требования по рефералам',
    'agent.logs.summary.open': 'Открыто',
    'agent.logs.summary.locked': 'Заблокировано',
    'agent.logs.summary.loading': 'Загрузка…',
  },
  bn: {
    'agent.logs.emptyTitle': 'কোনো উত্তোলন পাওয়া যায়নি',
    'agent.logs.emptyDescAdjust': 'ফিল্টার বা তারিখের পরিসর সামঞ্জস্য করে দেখুন',
    'agent.logs.subtitle': 'সমস্ত উত্তোলন অনুরোধের সম্পূর্ণ ইতিহাস',
    'agent.logs.loadingRows': 'উত্তোলন লোড হচ্ছে…',
    'agent.logs.col.dateTime': 'তারিখ ও সময়',
    'agent.logs.col.amount': 'পরিমাণ',
    'agent.logs.col.wallet': 'ওয়ালেট',
    'agent.logs.col.network': 'নেটওয়ার্ক',
    'agent.logs.col.fee': 'ফি',
    'agent.logs.col.status': 'স্থিতি',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'প্রক্রিয়াকৃত',
    'agent.logs.expanded.txId': 'লেনদেন ID',
    'agent.logs.expanded.fullWallet': 'সম্পূর্ণ ওয়ালেট ঠিকানা',
    'agent.logs.expanded.network': 'নেটওয়ার্ক',
    'agent.logs.expanded.processingTime': 'প্রক্রিয়াকরণ সময়',
    'agent.logs.awaitingReview': 'পর্যালোচনাধীন',
    'agent.logs.failedHelp': 'এই উত্তোলন ব্যর্থ হয়েছে। TXID {{txid}} দিয়ে সাপোর্টে যোগাযোগ করুন।',
    'agent.logs.pendingNotice': 'উত্তোলন পর্যালোচনাধীন। প্রক্রিয়াকরণ ২৪–৪৮ ঘণ্টা।',
    'agent.logs.status.completed': 'সম্পন্ন',
    'agent.logs.status.pending': 'মুলতুবি',
    'agent.logs.status.failed': 'ব্যর্থ',
    'agent.logs.filter.all': 'সব',
    'agent.logs.filter.from': 'থেকে',
    'agent.logs.filter.to': 'পর্যন্ত',
    'agent.logs.filter.searchPlaceholder': 'TXID বা ওয়ালেট খুঁজুন…',
    'agent.logs.summary.totalWithdrawn': 'মোট উত্তোলন',
    'agent.logs.summary.lastWithdrawal': 'সর্বশেষ উত্তোলন',
    'agent.logs.summary.nextAvailable': 'পরবর্তী উপলব্ধ',
    'agent.logs.summary.subTotalWithdrawn': 'সফল উত্তোলন',
    'agent.logs.summary.subNextOpen': 'এখন অনুরোধ করতে পারেন',
    'agent.logs.summary.subNextLocked': 'রেফারেল শর্ত পূরণ করুন',
    'agent.logs.summary.open': 'খোলা',
    'agent.logs.summary.locked': 'লক',
    'agent.logs.summary.loading': 'লোড হচ্ছে…',
  },
  hi: {
    'agent.logs.emptyTitle': 'कोई निकासी नहीं मिली',
    'agent.logs.emptyDescAdjust': 'फ़िल्टर या तिथि सीमा समायोजित करके देखें',
    'agent.logs.subtitle': 'सभी निकासी अनुरोधों का पूरा इतिहास',
    'agent.logs.loadingRows': 'निकासी लोड हो रही है…',
    'agent.logs.col.dateTime': 'दिनांक और समय',
    'agent.logs.col.amount': 'राशि',
    'agent.logs.col.wallet': 'वॉलेट',
    'agent.logs.col.network': 'नेटवर्क',
    'agent.logs.col.fee': 'शुल्क',
    'agent.logs.col.status': 'स्थिति',
    'agent.logs.col.txid': 'TXID',
    'agent.logs.col.processedIn': 'संसाधित',
    'agent.logs.expanded.txId': 'लेन-देन ID',
    'agent.logs.expanded.fullWallet': 'पूरा वॉलेट पता',
    'agent.logs.expanded.network': 'नेटवर्क',
    'agent.logs.expanded.processingTime': 'प्रसंस्करण समय',
    'agent.logs.awaitingReview': 'समीक्षाधीन',
    'agent.logs.failedHelp': 'यह निकासी विफल रही। TXID {{txid}} के साथ सहायता से संपर्क करें।',
    'agent.logs.pendingNotice': 'निकासी समीक्षाधीन है। प्रसंस्करण 24–48 घंटे।',
    'agent.logs.status.completed': 'पूर्ण',
    'agent.logs.status.pending': 'लंबित',
    'agent.logs.status.failed': 'विफल',
    'agent.logs.filter.all': 'सभी',
    'agent.logs.filter.from': 'से',
    'agent.logs.filter.to': 'तक',
    'agent.logs.filter.searchPlaceholder': 'TXID या वॉलेट खोजें…',
    'agent.logs.summary.totalWithdrawn': 'कुल निकासी',
    'agent.logs.summary.lastWithdrawal': 'अंतिम निकासी',
    'agent.logs.summary.nextAvailable': 'अगला उपलब्ध',
    'agent.logs.summary.subTotalWithdrawn': 'सफल निकासी',
    'agent.logs.summary.subNextOpen': 'अब अनुरोध भेज सकते हैं',
    'agent.logs.summary.subNextLocked': 'रेफरल आवश्यकताएँ पूरी करें',
    'agent.logs.summary.open': 'खुला',
    'agent.logs.summary.locked': 'लॉक',
    'agent.logs.summary.loading': 'लोड हो रहा है…',
  },
};
